import {useLocalStorage} from '@github-ui/use-safe-storage/local-storage'
import {
  AUTO_REFRESH_STORAGE_KEY,
  type AutoRefreshOptionId,
  DEFAULT_AUTO_REFRESH_OPTION_ID,
  isAutoRefreshOptionId,
} from '../../components/workflow-runs/workflow-runs-auto-refresh'

const STORAGE_OPTIONS = {validator: isAutoRefreshOptionId}

// The server can't read local storage, so server and hydration renders use the default and the saved value applies
// after hydration.
export function useAutoRefreshPreference() {
  const [value, setValue] = useLocalStorage<AutoRefreshOptionId>(
    AUTO_REFRESH_STORAGE_KEY,
    DEFAULT_AUTO_REFRESH_OPTION_ID,
    STORAGE_OPTIONS,
  )
  return [value, setValue] as const
}
